// Common
import transfer_logo from '/app/assets/images/transfer.png'

export default class CampListTransferDesktop extends React.Component {
    render() {
        return (
            <div className='card card_big camp-list-transfer'>
                <div className='col-12'>
                    <img className='img' src={transfer_logo}/>
                    <div className='text'>
                        <h3 className='camp-list-transfer__title'>Трансфер в подарок</h3>
                        <p className='text-sub'>Встретим вас от ж/д вокзала или аэропорта и доставим до объекта размещения.</p>
                        <a href='/pages/promo'
                           className='camp_link link text_f14 under under_line before-ico before-ico_arrow before-ico_arrow_green'>
                            Подробнее об акции
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
